<!-- TruncatedHtml.vue -->
<template>
  <div class="relative group">
    <div ref="truncatedContent" class="truncate max-h-[24px] overflow-hidden" v-html="content" />
    <div
      v-if="isContentTruncated"
      class="absolute z-50 invisible group-hover:visible bg-white dark:bg-gray-800 p-2 rounded shadow-lg border border-gray-200 dark:border-gray-700 min-w-[200px] max-w-[400px]"
      v-html="content" />
  </div>
</template>

<script>
export default {
  name: "TruncatedHtml",
  props: {
    content: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isContentTruncated: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      const element = this.$refs.truncatedContent
      this.isContentTruncated = element.scrollHeight > element.clientHeight
    })
  }
}
</script>

<style scoped>
.truncate {
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
